<template>
  <search-dropdown :value="value" @input="$emit('input', $event)" :options="options" :option-value-field="field" :option-label-field="field" :placeholder="placeholder"></search-dropdown>
</template>

<script>
import SearchDropdown from '@/components/SearchDropdown'
import { ReportsApi } from '@/reports/api'

export default {
  data () {
    return {
      options: []
    }
  },
  props: {
    value: { type: String, required: true },
    field: { type: String, required: true },
    filters: { type: Array, required: false, default: () => { return [] } },
    placeholder: { type: String, required: false },
    date: { type: Object, required: true },
  },
  computed: {
    query () {
      let options = {
        fields: [this.field],
        stats: [],
        startTime: this.start,
        endTime: this.end,
        filters: this.filters
      }
      return options
    },
    start () {
      if ('start' in this.date) {
        return this.date.start
      } else {
        return moment().utc().subtract(24, 'hours').valueOf()
      }
    },
    end () {
      if ('end' in this.date) {
        return this.date.end
      } else {
        return this.endTime || moment().utc().valueOf()
      }
    }
  },
  methods: {
    fetchOptions () {
      ReportsApi.bqreport(this.query, this).then((data) => {
        this.options = data.results
      }, (e) => {
        console.error(e)
      })
    }
  },
  watch: {
    date: {
      deep: true,
      handler: function () {
        this.fetchOptions();
      }
    }
  },
  components: {
    SearchDropdown
  }
}
</script>


// WEBPACK FOOTER //
// src/reports/components/PopulatingFilterDropdown.vue